import React, { FC, MouseEvent } from "react";

import { PrevNextSelectMonthly } from "~/components/molecules";

import { OriginalCalendar } from "./OriginalCalendar";

type PropsType = {
  dailyActivity?: {
    date: string;
    postsCount: number;
  }[];
  targetDate: Date;
  isLoading: boolean;
  isForRate: boolean;
  title?: string;
  onPrevMonthClick: (e: MouseEvent<HTMLButtonElement>) => void;
  onNextMonthClick: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

export const ActivityOriginalCalendar: FC<PropsType> = ({
  dailyActivity,
  targetDate,
  isLoading,
  isForRate,
  title,
  onPrevMonthClick,
  onNextMonthClick,
  className = "",
}: PropsType) => {
  const [isTransitioning, setIsTransitioning] = React.useState(false);

  const handlePrevMonth = (e: MouseEvent<HTMLButtonElement>) => {
    setIsTransitioning(true);
    onPrevMonthClick(e);
    setTimeout(() => setIsTransitioning(false), 300);
  };

  const handleNextMonth = (e: MouseEvent<HTMLButtonElement>) => {
    setIsTransitioning(true);
    onNextMonthClick(e);
    setTimeout(() => setIsTransitioning(false), 300);
  };

  return (
    <div className={`${className}`}>
      {title && (
        <p className="font-semibold text-primary-600 text-lg text-center mb-2 transition-all duration-300">
          {title}
        </p>
      )}
      <PrevNextSelectMonthly
        targetDate={targetDate}
        onPrevMonthClick={handlePrevMonth}
        onNextMonthClick={handleNextMonth}
      />
      <div
        className={`transition-all duration-300 ease-in-out ${
          isTransitioning ? "opacity-70 scale-98" : "opacity-100 scale-100"
        }`}
      >
        <OriginalCalendar
          isLoading={isLoading}
          targetDate={targetDate}
          dailyActivity={dailyActivity}
          isForRate={isForRate}
          className="mt-3"
        />
      </div>
    </div>
  );
};
